import styled from '@emotion/styled';

const baseTextareaPadding = 10;
const submitBtnSize = 38;
const buttonsSpacing = 10;
const buttonsCount = 2;

export const editorPaddingRight =
  baseTextareaPadding + submitBtnSize * buttonsCount + buttonsSpacing * (buttonsCount - 1);

export const uploadButtonHeight = 32;

export const EditorWrapper = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  backgroundColor: theme.palette.white.main,
  borderRadius: 5,
  border: `2px solid ${theme.palette.gray.light2}`,
  outline: 'none',
  resize: 'none',
  padding: baseTextareaPadding,
  paddingRight: editorPaddingRight,
  paddingBottom: baseTextareaPadding + uploadButtonHeight,
  width: '100%',

  fontFamily: theme.fonts.regular,
  fontSize: 16,
  color: theme.palette.black.light1,
  transition: 'border 0.3s',

  '&:hover': {
    border: `2px solid ${theme.palette.primary.main}`,
  },

  '&:focus-within': {
    border: `2px solid ${theme.palette.primary.main}`,
  },

  '& .ProseMirror, & .remirror-editor.ProseMirror': {
    outline: 'none',
    minHeight: 66,
    maxHeight: 390,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',

    '& p': {
      margin: 0,
    },

    '& .remirror-is-empty:first-of-type::before': {
      content: 'attr(data-placeholder)',
      color: theme.palette.gray.main,
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
}));
